import { CustomerInfoSuccess } from '../../actionTypes/profileManagementActions';

const inititalState = {
  customerInformation: {},
};

export const profileManagementReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CustomerInfoSuccess:
      return {
        ...state,
        customerInformation: payload,
      };
    default:
      return state;
  }
};
